export const isTrackOrLessonCardModel = item => item.type === 'TRACK' || item.type === 'LESSON';
export const isShortCardModel = item => item.type === 'SHORT_FORM_CONTENT';
export const isTrackCardModel = item => item.type === 'TRACK';